<template lang="pug">
v-card(outlined).mb-5
  v-card-title.title Настройки часового пояса
  v-card-text.d-flex.align-center.justify-center
    select-timezones.mr-4(
      v-model="selectedZone"
      filled
      dense
      hide-details
    )
    v-btn.rounded.mr-4(
      color="success"
      :disabled="checkCanSet"
      @click="setSelectedZone"
    ) Поменять
    v-tooltip(v-if="!isRegion" bottom) Настройки
      template(#activator="{ on }")
        v-btn.rounded(
          v-on="on"
          @click="openEditForm"
          fab
          x-small
          color="primary"
        )
          v-icon mdi-wrench
    span.font-weight-light.mt-5(
      v-if="isAdmin || isSupport"
      @click="openCreateForm"
      @mouseenter="createSpan = true"
      @mouseleave="createSpan = false"
      :class="createSpan ? 'primary--text' : '' "
    ) Создать новый часовой пояс.
  event-form(
    :data="editFormData"
    :value="eventForm"
    @close="closeForm"
  )
</template>
<script>
import { showRegion } from '@/services/API/_common';
import CRUDTimezones from '@/services/API/timezone';
import EventForm from './EventForm.vue';
import {  mapGetters, mapMutations } from 'vuex';
import selectTimezones from './SelectTimezone.vue';
import CRUDRegionSettings from '@/services/API/region-settings';

export default {
  components: {
    selectTimezones,
    EventForm,
  },
  data() {
    return {
      region: {},
      regionSettings: {},
      editFormData: false,
      editForm: false,
      eventForm: false,
      createSpan: false,
      selectedZone: null,
      SwitchZone: false,
    };
  },
  computed: {
    ...mapGetters({
      user:'auth/getUser',
      isSupport: 'auth/isSupport',
      isAdmin:'auth/isAdmin',
      isRegion: 'auth/isRegion',
      timezone: 'auth/timezone',
    }),
    checkCanSet() {
      return this.user.region_id && this.user.timezone.id === this.selectedZone && this.selectedZone;
    },
  },
  async createRegionSettings() {
    try {
      const params = {
        'region_id': this.region.id,
        'client_question_auto_close_day': 1,
        'timezone_id': 1,
      };
      await CRUDRegionSettings.create(params);
    } catch (e) {
      this.$toast.error(e.response.data.result_message);
    }
  },
  async created() {
    this.setDefaultValueSelectedZone();
    await this.fetchRegion();
    if (!this.region.region_setting) await this.createRegionSettings();
    await this.fetchRegionSettings();
  },
  methods: {
    ...mapMutations({
      SET_USER: 'auth/SET_USER',
    }),
    async getID() {
      try {
        const response = await CRUDTimezones.get(this.selectedZone);
        this.editFormData = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    setDefaultValueSelectedZone() {
      if (this.user.timezone) this.selectedZone = this.user.timezone.id;
    },
    async openEditForm() {
      await this.getID();
      this.eventForm = true;
    },
    openCreateForm() {
      this.eventForm = true;
    },
    closeForm() {
      this.editFormData = false;
      this.eventForm = false;
    },
    async fetchRegion() {
      const { region_id } = this.user;
      if (!region_id) return;
      try {
        const response = await showRegion(region_id, { 'expand': 'region_setting' });
        this.region = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async fetchRegionSettings() {
      const { id } = this.region.region_setting;
      if (!id) return;
      try {
        const response = await CRUDRegionSettings.get(id);
        this.regionSettings = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async setSelectedZone() {
      try {
        const { id } = this.region.region_setting;
        const params = {
          'client_question_auto_close_day': this.regionSettings.client_question_auto_close_day,
          'timezone_id': this.selectedZone,
        };
        await CRUDRegionSettings.update(id, params);
        const timezone = await CRUDTimezones.get(this.selectedZone);
        this.SET_USER({ ...this.user, timezone:timezone.data.data });
        this.$toast.success('Вы успешно поменяли часовой пояс');
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
  },
};
</script>
<style scoped/>
